export enum ConsumptionSummaryTypeEnum {
    CALL = "CALL",
    DATA = "DATA",
    SMS = "SMS"
}